import remodal from "remodal";

export default function(){

    $('.remodal-close').on('click',function(){
        let $target = $(this).parent('div.remodal');
        var video;
        video = $(this).next('.js-video-modal').detach();
        $(video).appendTo($target);
    });

    setTimeout(function(){
        $('.remodal-wrapper').on('click',function(){
            let $target = $(this).children('div.remodal');
            var video;
            video = $(this).children('div.remodal').children('.js-video-modal').detach();
            $(video).appendTo($target);
        });
    },500);

}
